import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  tableContainer: {
    flex: 1,
    margin: '20px 2% 20px 34px',
  },
  readOnlyAlert: {
    padding: `${spacing(12)}px ${spacing(16)}px !important`,

    '& .MuiAlertTitle-root': {
      marginTop: 0,
      marginBottom: 0,
    },

    '& .ReferaAlert__content': {
      marginTop: spacing(8),
      paddingBottom: 0,
    },

    '& .ReferaAlert__content:empty': {
      display: 'none',
      margin: 0,
    },
  },
}))
